import { useEffect } from 'react';
import { MotionConfig } from 'motion/react';
import { RouterProvider } from 'react-router';
import { Toaster } from '@/components/Toaster';
import { useLocaleStore } from '@/locales';
import { useSessionStore } from '@/stores/session.store';
import { router } from './router';

export function App() {
  const locale = useLocaleStore((s) => s.locale);

  useEffect(() => {
    void useSessionStore.getState().restore();
  }, []);

  useEffect(() => {
    document.documentElement.lang = locale;
  }, [locale]);

  return (
    <MotionConfig reducedMotion="user">
      <RouterProvider router={router} />
      <Toaster />
    </MotionConfig>
  );
}
